// AuthContent.js
import React from "react";
import { Col } from "react-bootstrap";
import AuthBg from "../../assets/images/auth-bg.jpg";

const AuthContent = () => {
  return (
    <Col
      xs={12}
      md={6}
      className="text-white p-4 p-md-5 d-flex flex-column justify-content-center align-items-center" // Adjusted padding for better mobile responsiveness
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${AuthBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="text-center px-md-5">
        <h1 className="display-4 mb-4" style={{ fontSize: "2.5rem" }}>
          Welcome
        </h1>

        <p className="fs-6 mt-3 text-dark">
          
        </p>
      </div>
    </Col>
  );
};

export default AuthContent;
